import React from "react";
import { NumericFormat } from 'react-number-format';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import { PaymentMethods, useMasterData } from "../../../../core";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DateInput, TextInput } from "../../../../components/form-group";
import NumberInput from "../../../../components/form-group/number-input";
import api from "../../../../api";
import { DragDropFile, DragDropUploadPDF } from "../../../../components/upload";
import { UploadTabNames } from "./props";

const paymentMethods = [
    {
        name: "Cash",
        value: PaymentMethods.Cash,
    },
    {
        name: "Credit Card",
        value: PaymentMethods.CreditCard,
    },
    {
        name: "Debit Card",
        value: PaymentMethods.DebitCard,
    },
    // {
    //     name: "American Express",
    //     value: PaymentMethods.AmericanExpress,
    // },
    {
        name: "Bank Transfer",
        value: PaymentMethods.BankTransfer,
    },
    {
        name: "Cheque",
        value: PaymentMethods.Cheque,
    },
    // {
    //     name: "Web Payment",
    //     value: PaymentMethods.WebPayment,
    // },
    // {
    //     name: "Send Payment Link",
    //     value: "SendPaymentLink",
    // },
];

const banks = [
    { name: "State Bank of India (SBI)" },
    { name: "HDFC Bank" },
    { name: "ICICI Bank" },
    { name: "Punjab National Bank (PNB)" },
    { name: "Axis Bank" },
    { name: "Bank of Baroda (BOB)" },
    { name: "Canara Bank" },
    { name: "Union Bank of India" },
    { name: "IDBI Bank" },
    { name: "Kotak Mahindra Bank" },
    { name: "IndusInd Bank" },
    { name: "Yes Bank" },
    { name: "Bank of India (BOI)" },
    { name: "Central Bank of India" },
    { name: "Indian Bank" },
    { name: "Indian Overseas Bank" },
    { name: "Federal Bank" },
    { name: "Punjab & Sind Bank" },
    { name: "Karnataka Bank" },
    { name: "South Indian Bank" },
    { name: "Corporation Bank" },
    { name: "Dena Bank" },
    { name: "Vijaya Bank" },
    { name: "RBL Bank" },
    { name: "UCO Bank" },
    { name: "Allahabad Bank" },
    { name: "Andhra Bank" },
    { name: "Bank of Maharashtra" },
    { name: "Syndicate Bank" },
    { name: "Tamilnad Mercantile Bank (TMB)" },
    { name: "Karur Vysya Bank (KVB)" },
    { name: "City Union Bank" },
    { name: "Lakshmi Vilas Bank" },
    { name: "Nainital Bank" },
    { name: "Jammu & Kashmir Bank" },
    { name: "Kerala Gramin Bank" },
    { name: "Kerala State Cooperative Bank" },
    { name: "Gujarat State Cooperative Bank" },
    { name: "Saraswat Bank" },
    { name: "Punjab State Cooperative Bank" },
    { name: "Rajasthan State Cooperative Bank" },
    { name: "Uttar Pradesh Cooperative Bank" },
    { name: "Madhya Pradesh Rajya Sahakari Bank" },
    { name: "Maharashtra State Cooperative Bank" },
    { name: "TJSB Sahakari Bank" },
    { name: "Shamrao Vithal Co-operative Bank" },
    { name: "Thane Bharat Sahakari Bank" },
    { name: "Goa Urban Co-operative Bank" },
    { name: "Kalupur Commercial Co-operative Bank" },
    { name: "Maharashtra Gramin Bank" },
    { name: "Andhra Pradesh Grameena Vikas Bank" },
    { name: "Pragathi Krishna Gramin Bank" },
    { name: "Narmada Jhabua Gramin Bank" },
    { name: "Baroda Uttar Pradesh Gramin Bank" },
    { name: "Meghalaya Rural Bank" },
    { name: "Sikkim State Co-operative Bank" },
    { name: "Meghalaya Co-operative Apex Bank" },
    { name: "Mizoram Rural Bank" },
    { name: "Nagaland State Co-operative Bank" },
    { name: "Arunachal Pradesh Rural Bank" },
    { name: "Bank of America" },
    { name: "Citibank" },
    { name: "Deutsche Bank" },
    { name: "HSBC India" },
    { name: "Standard Chartered Bank" },
    { name: "DBS Bank" },
    { name: "American Express Bank" }
];

export interface PaymentFormProps {
    paymentMethod: string;
    bank: string;
    receipt: string;
    date: any;
    amountPaid: number;
    paidBy: string;
    comments: string;
    invoiceCopyType?: string
}
const InvoicePaymentForm : React.FunctionComponent<{
    onSubmit: SubmitHandler<any>;
    setMarkAsPaidModalOpen:  any;
    isSaving: boolean;
    proposalDocument: any;
    tabName?:UploadTabNames
  }> = (props)=>{
    const {
        control,
        handleSubmit,
        errors,
        watch,
        getValues
    } = useForm<PaymentFormProps>({
        reValidateMode: "onChange",
        mode: "onSubmit",
        defaultValues: {
            paymentMethod :PaymentMethods.Cash,
        }
    });
    const masterData = useMasterData(api.settings);
    const date = watch("date") || new Date();

    const pendingAmount =()=>{
        if(props.tabName === UploadTabNames.InvoiceForCustomer){
            return ((props.proposalDocument?.document?.paymentDetails?.amount + props.proposalDocument?.document?.paymentDetails?.taxCgst + props.proposalDocument?.document?.paymentDetails?.taxSgst) - props.proposalDocument?.document?.paymentDetails?.amountPaid)
        }else if(props.tabName === UploadTabNames.InvoiceForLandlord){
            return ((props.proposalDocument?.seperateDocumentForLandlord?.paymentDetails?.amount + props.proposalDocument?.seperateDocumentForLandlord?.paymentDetails?.taxCgst + props.proposalDocument?.seperateDocumentForLandlord?.paymentDetails?.taxSgst) - props.proposalDocument?.seperateDocumentForLandlord?.paymentDetails?.amountPaid)
        }else{
            return 0
        }

    }   

    const renderBank = () => {
        return (
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-normal">
                Bank<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                name="bank"
                rules={{ required: watch('transactionType') !== 'refund' }}
                // defaultValue={props?.transactionSelected?.card?.bank}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    data={banks}
                    placeholder="Bank"
                    onChange={(val) => onChange(val.name)}
                    name={name}
                    value={value}
                    textField="name"
                    valueField="name"
                    // disabled={!!props.transactionSelected?._id}
                  />
                )}
              ></Controller>
              {errors.bank && <ErrorMessage>Bank is Required</ErrorMessage>}
            </div>
        );
      };

      const renderFile = () => {    
        return (
              <div className="form-group font-weight-semibold mb-4">
                <div className="drag-drop-file">
                  <Controller
                    control={control}
                    name="receipt"
                    rules={{ required: 'Receipt is Required' }}
                    render={({ onChange, value, name }) => (
                        <DragDropUploadPDF
                            value={value}
                            name="receipt"
                            id="receipt"
                            onFileChosen={onChange}
                            title="Bank receipt"
                        />
                    )}
                  />
                </div>
                {errors.receipt && !watch('receipt') && (
                  <ErrorMessage>Receipt is Required</ErrorMessage>
                )}
              </div>
        );
      };
    
    return (
        <form onSubmit={handleSubmit(props.onSubmit)}>
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                    Payment Method<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    rules={{ required: "Payment Method is Required" }}
                    name="paymentMethod"
                    // defaultValue={}
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            defaultValue={value}
                            data={paymentMethods}
                            textField={"name"}
                            valueField={"value"}
                            placeholder={"Payment Method"}
                            onChange={(val) => {
                                onChange(val.value);
                            }}
                            filter={"contains"}
                        />
                    )}
                />
                {errors.paymentMethod && <ErrorMessage>{errors.paymentMethod?.message}</ErrorMessage>}
            </div>
            {watch('paymentMethod') &&
                  watch('paymentMethod') !== PaymentMethods.Cash &&
                //   watch('paymentMethod') !== PaymentMethods.AmericanExpress &&
                //   watch('paymentMethod') !== PaymentMethods.KNet &&
                  watch('paymentMethod') !== PaymentMethods.CreditCard &&
                  watch('paymentMethod') !== PaymentMethods.DebitCard &&
                //   watch('paymentMethod') !== PaymentMethods.SendPaymentLink &&
                //   watch('paymentMethod') !== PaymentMethods.WebPayment &&
                //   watch('paymentMethod') !== PaymentMethods.WithoutPayment &&
                   (
                    renderBank()
                  )}
                {(watch('paymentMethod') === PaymentMethods.BankTransfer ||
                  watch('paymentMethod') === PaymentMethods.Cheque) &&
                  watch('transactionType') !== 'refund' &&
                  renderFile()}
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                    Amount<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    name="amountPaid"
                    rules={{
                        required: "Payment Amount is Required",
                        validate: {
                            valid: (value) =>
                                !value || (!isNaN(Number(value)) && Number(value) > 0) || "Invalid Payment Amount",
                            // minimum: (value) =>
                            //   !value ||
                            //   !props.minimumAmount ||
                            //   Number(value) >= Number(props.minimumAmount?.toFixed(2)) ||
                            //   `Minimum Payment Amount is ${props.minimumAmount?.toFixed(2)}`,
                            positive: (value) =>
                                !value || Number(value) > 0 || `Payment Amount should be greater than zero`,
                        },
                    }}
                    // defaultValue={0}
                    render={({ onChange, value, name }) => (
                        <NumericFormat 
                            value={value}
                            decimalScale={2}
                            placeholder="Payment Amount"
                            onChange={onChange}
                            className="form-control font-weight-semibold"
                         />
                    )}
                ></Controller>
                 {errors.amountPaid && <ErrorMessage>{errors.amountPaid?.message}</ErrorMessage>}
            </div>
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                    Date<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    name="date"
                    rules={{ required: "Date is Required" }}
                    defaultValue={date}
                    render={({ onChange, value, name }) => (
                        <DateInput
                            dateFormat="dd-MMM-yyyy"
                            default={value}
                            placeholder={"Date"}
                            onChange={onChange}
                        />
                    )}
                ></Controller>
                {errors.date && <ErrorMessage>Date of birth is required</ErrorMessage>}
            </div>
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                    Paid By
                </label>
                <Controller
                    control={control}
                    name="paidBy"
                    defaultValue={""}
                    render={({ onChange, value, name }) => (
                        <TextInput
                            gap="sm"
                            type="text"
                            placeholder="Paid By"
                            label=""
                            onChange={onChange}
                            name={name}
                            default={value}
                            className="form-control font-weight-semibold"
                        />
                    )}
                ></Controller>
            </div>
            <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase">
                    Comments
                </label>
                <Controller
                    control={control}
                    name="comments"
                    // rules={{ required: watch("transactionType") !== "receipt" }}
                    render={({ onChange, value, name }) => (
                        <textarea
                            onChange={(e) => {
                                onChange(e.target.value);
                            }}
                            placeholder="Comments"
                            value={value}
                            className="form-control font-weight-semibold h-auto"
                            rows={3}
                        ></textarea>
                    )}
                ></Controller>
                {errors.comments && <ErrorMessage>comments is Required</ErrorMessage>}
            </div>
            <div className="form-group font-weight-semibold mb-4">
             Pending Amount : ₹{(pendingAmount()  - (watch('amountPaid') || 0)).toLocaleString('en-IN')  || 0}
            </div>
            <div className="d-flex justify-content-end">
                <div >
                    <button
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal  px-4 mr-3"
                        onClick={() => {
                            props.setMarkAsPaidModalOpen(false);
                        }}
                        disabled={props.isSaving}
                    >
                        Cancel
                    </button>
                </div>
                <div >
                    <button
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                        disabled={props.isSaving}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </form>
    );
};
export default InvoicePaymentForm;